/**
 * The seafarer's clinical crew portal (Form A, on the SeaScope platform
 * itself — not this marketing site). Founder ruling, 22 Sep 2026: one
 * constant, reused everywhere the link appears.
 */
export const CREW_PORTAL_URL = 'https://app.seascope.tech/crew-portal';

/** Crew Wellness app — a different thing from the crew portal above: readings
 * between medicals, not Form A. */
export const CREW_WELLNESS_URL = 'https://app.seascope.tech/crew/';

const UNAVAILABLE = { href: null, label: 'Use your personal link', availability: 'unavailable' };

/** A marketing destination only; the application owns password, identity and session checks. */
export function getCrewEntry({ applicationOrigin, intakeAvailable, preview }) {
  if (!intakeAvailable || typeof intakeAvailable !== 'boolean' || typeof preview !== 'boolean') {
    return UNAVAILABLE;
  }
  if (typeof applicationOrigin !== 'string' || applicationOrigin !== applicationOrigin.trim()) {
    return UNAVAILABLE;
  }
  let origin;
  try {
    const url = new URL(applicationOrigin);
    if (url.username || url.password || url.search || url.hash || url.pathname !== '/') return UNAVAILABLE;
    origin = url.origin;
  } catch {
    return UNAVAILABLE;
  }
  if (preview && origin === 'http://127.0.0.1:3877') {
    return { href: `${origin}/crew-portal`, label: 'Open crew intake preview', availability: 'preview' };
  }
  if (!preview && origin === 'https://app.seascope.tech') {
    return { href: CREW_PORTAL_URL, label: 'Open crew medical portal', availability: 'available' };
  }
  return UNAVAILABLE;
}

/** Missing or malformed build flags never activate an application link. */
export function getConfiguredCrewEntry() {
  const env = import.meta.env || {};
  if (!['0', '1'].includes(env.VITE_CREW_INTAKE_AVAILABLE)
      || !['0', '1'].includes(env.VITE_MARKETING_PREVIEW)) return UNAVAILABLE;
  return getCrewEntry({
    applicationOrigin: env.VITE_APPLICATION_ORIGIN,
    intakeAvailable: env.VITE_CREW_INTAKE_AVAILABLE === '1',
    preview: env.VITE_MARKETING_PREVIEW === '1',
  });
}
